import React, { useState, useRef, useEffect } from "react";
import DragNDropGrid from './DragNDropGrid';
import RoundEdgeButton from './RoundEdgeButton';

// Constant error messages
const WRONG_TOY_MESSAGES = [
    "Oops! Wrong toys. Check the bottom-left corner to see the correct toys.",
    "Please select what you see!",
    "Incorrect selection. The toys you need are displayed in the bottom-left corner on screen.",
    "Not quite! Try selecting the toys again.",
    "Almost! Please select the correct toys and try again."
];

function OnsiteVerifyingPage({
    onStartConnection,
    authFailed,
    onResetAuthFailed,
}) {
    const [selectedItems, setSelectedItems] = useState([]);
    const [unmatchedText, setUnmatchedText] = useState('');
    const resetItemsRef = useRef(null);

    // Handle authentication failure
    useEffect(() => {
        if (authFailed) {
            const randomIndex = Math.floor(Math.random() * WRONG_TOY_MESSAGES.length);
            setUnmatchedText(WRONG_TOY_MESSAGES[randomIndex]);
            if (resetItemsRef.current && resetItemsRef.current.handleReset)
                resetItemsRef.current.handleReset();

            if (onResetAuthFailed)
                onResetAuthFailed();
        }
    }, [authFailed, onResetAuthFailed]);

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleConnect = () => {
        if (selectedItems.length === 0) {
            const randomIndex = Math.floor(Math.random() * WRONG_TOY_MESSAGES.length);
            setUnmatchedText(WRONG_TOY_MESSAGES[randomIndex]);
            return;
        }
        // Create token from selected items
        const token = selectedItems.join(', ');

        if (!onStartConnection) {
            console.error("❌ ERROR: onStartConnection is UNDEFINED!");
            return;
        }

        onStartConnection(token);
    };

    return (
        <div>
            <DragNDropGrid
                ref={resetItemsRef}
                onSetSelectedItems={setSelectedItems}
            />

            {/* Connect button (right side) */}
            <div style={{
                position: 'absolute',
                right: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
            }}>
                <RoundEdgeButton
                    onClick={() => { handleConnect(); }}
                    variant='roundEdgeInBlack'
                >
                    &#x23CE;
                </RoundEdgeButton>
            </div>

            {/* Back/Refresh button (left side) */}
            <div style={{
                position: 'absolute',
                left: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
            }}>
                <RoundEdgeButton
                    onClick={handleRefresh}
                    variant='roundEdgeInBlack'
                >
                    &#x21E6;
                </RoundEdgeButton>
            </div>
            {/* Error message display */}
            <div style={{
                position: 'absolute', bottom: '12.5px', fontSize: '15px',
                height: '50px', width: '280px', textAlign: 'center',
                left: '50%', transform: 'translateX(-50%)',
                color: 'red'
            }}>
                {unmatchedText}
            </div>

        </div>
    );
}

export default OnsiteVerifyingPage;
